import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../api-slice';
import { ResponsePurchaseListSchema } from './purchase.schema';

export const purchasesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createPurchases: builder.mutation({
            query: (data) => ({
                url: 'purchases',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Purchases', 'Inventory_Sale'],
        }),

        getPurchaseReportPdf: builder.mutation({
            query: (params) => {
                return {
                    url: 'purchases/pdf',
                    method: 'GET',
                    params,
                    responseHandler: (response) => response.blob(),
                };
            },
        }),

        getAllPurchases: builder.query({
            query: (params) => ({
                url: 'purchases',
                method: 'GET',
                params,
            }),
            providesTags: ['Purchases'],
            transformResponse: (response) => {
                return ResponsePurchaseListSchema.parse(response);
            },
        }),

        getPurchaseDetailsById: builder.query({
            query: (id: string) => ({
                url: `purchases/${id}`,
                method: 'GET',
            }),
            providesTags: (_result, _error, id) => [
                { type: SLICE_TAG.PURCHASES, id },
            ],
        }),

        createPrePurchase: builder.mutation({
            query: (data) => ({
                url: 'pre-purchases',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: [SLICE_TAG.PRE_PURCHASES],
        }),

        updatePrePurchase: builder.mutation({
            query: ({ id, ...data }) => ({
                url: `pre-purchases/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (_result, _error, { id }) => [
                { type: SLICE_TAG.PRE_PURCHASES, id },
                SLICE_TAG.PRE_PURCHASES,
            ],
        }),

        getPrePurchaseById: builder.query({
            query: (id: string) => ({
                url: `pre-purchases/${id}`,
                method: 'GET',
            }),
            providesTags: (_result, _error, id) => [
                { type: SLICE_TAG.PRE_PURCHASES, id },
            ],
        }),

        getPrePurchases: builder.query({
            query: (params) => ({
                url: 'pre-purchases',
                method: 'GET',
                params,
            }),
            providesTags: [SLICE_TAG.PRE_PURCHASES],
            // transformResponse: (response) => {
            //     return ResponsePurchaseListSchema.parse(response);
            // },
        }),

        deletePrePurchaseById: builder.mutation({
            query: (id: string) => ({
                url: `pre-purchases/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [SLICE_TAG.PRE_PURCHASES],
        }),

        addPurchasePayment: builder.mutation({
            query: ({ purchaseId, ...data }) => ({
                url: `purchases/${purchaseId}/pay`,
                method: 'POST',
                body: {
                    amount: data.amount,
                },
            }),
            invalidatesTags: (_result, _error, { purchaseId }) => [
                { type: SLICE_TAG.PURCHASES, id: purchaseId },
                SLICE_TAG.PURCHASES,
            ],
        }),
    }),
});

export const {
    useCreatePurchasesMutation,
    useGetAllPurchasesQuery,
    useGetPurchaseReportPdfMutation,
    useGetPurchaseDetailsByIdQuery,
    useLazyGetAllPurchasesQuery,
    useLazyGetPurchaseDetailsByIdQuery,

    // Pre-Purchase Endpoints
    useCreatePrePurchaseMutation,
    useDeletePrePurchaseByIdMutation,
    useGetPrePurchaseByIdQuery,
    useGetPrePurchasesQuery,
    useLazyGetPrePurchaseByIdQuery,
    useLazyGetPrePurchasesQuery,

    useAddPurchasePaymentMutation,

    useUpdatePrePurchaseMutation,
} = purchasesApi;
